import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabase';

const PLAN_LABEL = { basico: 'Básico', profesional: 'Profesional', estudio: 'Estudio' };
const ESTADO_COLOR = {
  trial:    { bg: '#fef3c7', color: '#92400e', label: 'Trial' },
  activa:   { bg: '#dcfce7', color: '#166534', label: 'Activa' },
  vencida:  { bg: '#fee2e2', color: '#991b1b', label: 'Vencida' },
  cancelada:{ bg: '#f1f5f9', color: '#475569', label: 'Cancelada' },
};

async function adminFetch(path, options = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  return fetch(path, {
    ...options,
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`, ...options.headers },
  }).then(r => r.json());
}

async function accion(body) {
  return adminFetch('/api/admin-accion', { method: 'POST', body: JSON.stringify(body) });
}

// ─── Chip de estado ────────────────────────────────────────────────────────────
function EstadoChip({ estado }) {
  const s = ESTADO_COLOR[estado] || ESTADO_COLOR.cancelada;
  return <span style={{ background: s.bg, color: s.color, borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 600 }}>{s.label}</span>;
}

// ─── Modal detalle estudio ─────────────────────────────────────────────────────
function ModalDetalle({ estudio, onClose }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function cargar() {
      const { data: { session } } = await supabase.auth.getSession();
      const { data, error } = await supabase
        .rpc('admin_get_estudio_stats', { p_estudio_id: estudio.id });
      setStats(error ? null : data);
      setLoading(false);
    }
    cargar();
  }, [estudio.id]);

  const sub = estudio.suscripciones?.[0];
  const vence = sub?.estado === 'trial' ? sub?.trial_hasta : sub?.periodo_fin;

  const STAT = ({ label, valor, color }) => (
    <div style={{ background: 'var(--bg,#f8fafc)', border: '1px solid var(--border)', borderRadius: 10, padding: '14px 18px', textAlign: 'center' }}>
      <div style={{ fontSize: 28, fontWeight: 800, color: color || 'var(--text)' }}>{valor ?? '—'}</div>
      <div style={{ fontSize: 11, color: 'var(--text4)', marginTop: 2 }}>{label}</div>
    </div>
  );

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: 'var(--surface)', borderRadius: 14, width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>

        {/* Header */}
        <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--text)' }}>{estudio.nombre}</div>
            <div style={{ fontSize: 12, color: 'var(--text4)', marginTop: 3 }}>
              Registrado: {new Date(estudio.creado_en).toLocaleDateString('es-AR', { day:'2-digit', month:'long', year:'numeric' })}
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: 'var(--text4)', lineHeight: 1, padding: '2px 6px' }}>×</button>
        </div>

        <div style={{ padding: '20px 24px' }}>
          {/* Suscripción */}
          <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
            <div style={{ background: 'var(--bg,#f8fafc)', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 14px', fontSize: 12 }}>
              <span style={{ color: 'var(--text4)' }}>Plan: </span>
              <span style={{ fontWeight: 600, color: 'var(--text)' }}>{PLAN_LABEL[sub?.plan] || '—'}</span>
            </div>
            <div style={{ background: 'var(--bg,#f8fafc)', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 14px', fontSize: 12 }}>
              <span style={{ color: 'var(--text4)' }}>Estado: </span>
              <EstadoChip estado={sub?.estado || 'trial'} />
            </div>
            {vence && (
              <div style={{ background: 'var(--bg,#f8fafc)', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 14px', fontSize: 12 }}>
                <span style={{ color: 'var(--text4)' }}>Vence: </span>
                <span style={{ fontWeight: 600, color: 'var(--text)' }}>{new Date(vence).toLocaleDateString('es-AR')}</span>
              </div>
            )}
          </div>

          {/* Stats de uso */}
          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text4)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>Uso del sistema</div>
          {loading ? (
            <div style={{ textAlign: 'center', padding: 32, color: 'var(--text4)', fontSize: 13 }}>Cargando estadísticas...</div>
          ) : stats ? (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 20 }}>
              <STAT label="Clientes"     valor={Number(stats.clientes)}     color="#2563eb" />
              <STAT label="Expedientes"  valor={Number(stats.expedientes)}   color="#7c3aed" />
              <STAT label="Trámites"     valor={Number(stats.tramites)}      color="#0891b2" />
              <STAT label="Tareas"       valor={Number(stats.asignaciones)}  color="#d97706" />
            </div>
          ) : (
            <div style={{ color: 'var(--text4)', fontSize: 13, marginBottom: 20 }}>No se pudieron cargar las estadísticas.</div>
          )}

          {/* Miembros */}
          {stats?.miembros?.length > 0 && (
            <>
              <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text4)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>
                Miembros ({stats.miembros.length})
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {stats.miembros.map((m, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: 'var(--bg,#f8fafc)', borderRadius: 8, border: '1px solid var(--border)' }}>
                    <div style={{ width: 28, height: 28, borderRadius: '50%', background: m.rol === 'admin' ? '#2563eb' : '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: m.rol === 'admin' ? 'white' : '#64748b', flexShrink: 0 }}>
                      {(m.nombre || '?')[0].toUpperCase()}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>{m.nombre || '—'}</div>
                      <div style={{ fontSize: 11, color: 'var(--text4)' }}>{m.email}</div>
                    </div>
                    <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 10, background: m.rol === 'admin' ? '#eff6ff' : '#f1f5f9', color: m.rol === 'admin' ? '#1d4ed8' : '#64748b' }}>
                      {m.rol}
                    </span>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Tab Usuarios ──────────────────────────────────────────────────────────────
function TabUsuarios({ estudios, onRefresh }) {
  const [selected, setSelected] = useState(null);
  const [modalEstudio, setModalEstudio] = useState(null);
  const [meses, setMeses] = useState(1);
  const [dias, setDias] = useState(7);
  const [plan, setPlan] = useState('profesional');
  const [loading, setLoading] = useState('');
  const [ok, setOk] = useState('');

  async function run(acc, extra = {}) {
    setLoading(acc); setOk('');
    const r = await accion({ accion: acc, estudio_id: selected.id, ...extra });
    setLoading('');
    if (r.ok) { setOk('✓ Listo'); onRefresh(); setTimeout(() => setOk(''), 2500); }
    else { setOk('✗ ' + (r.error || 'Error desconocido')); }
  }

  const sub = selected?.suscripciones?.[0];
  const admin = selected?.estudio_miembros?.find(m => m.rol === 'admin');

  return (
    <div>
      {modalEstudio && <ModalDetalle estudio={modalEstudio} onClose={() => setModalEstudio(null)} />}
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ borderBottom: '1px solid var(--border)' }}>
            {['Estudio','Admin','Email','Plan','Estado','Vence',''].map(h => (
              <th key={h} style={{ textAlign: 'left', padding: '8px 12px', fontSize: 11, color: 'var(--text4)', fontWeight: 600, whiteSpace: 'nowrap' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {estudios.map(e => {
            const s = e.suscripciones?.[0];
            const adm = e.estudio_miembros?.find(m => m.rol === 'admin');
            const vence = s?.estado === 'trial' ? s?.trial_hasta : s?.periodo_fin;
            const isSelected = selected?.id === e.id;
            return (
              <React.Fragment key={e.id}>
                <tr style={{ borderBottom: '1px solid var(--border)', background: isSelected ? 'var(--accent-light, #eff6ff)' : 'transparent' }}>
                  <td style={{ padding: '10px 12px', fontWeight: 600, color: 'var(--text)' }}>{e.nombre}</td>
                  <td style={{ padding: '10px 12px', color: 'var(--text2)' }}>{adm?.profiles?.nombre || '—'}</td>
                  <td style={{ padding: '10px 12px', color: 'var(--text4)', fontSize: 12 }}>{adm?.profiles?.email || '—'}</td>
                  <td style={{ padding: '10px 12px', color: 'var(--text2)' }}>{PLAN_LABEL[s?.plan] || '—'}</td>
                  <td style={{ padding: '10px 12px' }}><EstadoChip estado={s?.estado || 'trial'} /></td>
                  <td style={{ padding: '10px 12px', color: 'var(--text4)', fontSize: 12 }}>
                    {vence ? new Date(vence).toLocaleDateString('es-AR') : '—'}
                  </td>
                  <td style={{ padding: '10px 12px', display: 'flex', gap: 6 }}>
                    <button onClick={() => setModalEstudio(e)}
                      style={{ fontSize: 12, padding: '4px 12px', borderRadius: 6, border: '1px solid #2563eb', background: 'transparent', color: '#2563eb', cursor: 'pointer', fontWeight: 600 }}>
                      Ver
                    </button>
                    <button onClick={() => setSelected(isSelected ? null : e)}
                      style={{ fontSize: 12, padding: '4px 12px', borderRadius: 6, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text2)', cursor: 'pointer' }}>
                      {isSelected ? 'Cerrar' : 'Gestionar'}
                    </button>
                  </td>
                </tr>
                {isSelected && (
                  <tr>
                    <td colSpan={7} style={{ padding: '20px 16px', background: '#f8fafc', borderBottom: '1px solid var(--border)' }}>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>

                        {/* Cambiar plan */}
                        <div style={{ background: 'white', border: '1px solid var(--border)', borderRadius: 10, padding: 16 }}>
                          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)', marginBottom: 10 }}>Cambiar plan</div>
                          <select value={plan} onChange={e => setPlan(e.target.value)}
                            style={{ width: '100%', marginBottom: 8, padding: '6px 8px', borderRadius: 6, border: '1px solid var(--border)', fontSize: 13 }}>
                            <option value="basico">Básico</option>
                            <option value="profesional">Profesional</option>
                            <option value="estudio">Estudio</option>
                          </select>
                          <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 8 }}>
                            <input type="number" min={1} max={24} value={meses} onChange={e => setMeses(+e.target.value)}
                              style={{ width: 60, padding: '6px 8px', borderRadius: 6, border: '1px solid var(--border)', fontSize: 13 }} />
                            <span style={{ fontSize: 12, color: 'var(--text4)' }}>mes(es)</span>
                          </div>
                          <button onClick={() => run('cambiar_plan', { plan, meses })} disabled={!!loading}
                            style={{ width: '100%', padding: '7px', background: '#2563eb', color: 'white', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                            {loading === 'cambiar_plan' ? 'Guardando...' : 'Aplicar'}
                          </button>
                        </div>

                        {/* Regalar meses */}
                        <div style={{ background: 'white', border: '1px solid var(--border)', borderRadius: 10, padding: 16 }}>
                          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)', marginBottom: 10 }}>Regalar meses gratis</div>
                          <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 8 }}>
                            <input type="number" min={1} max={12} value={meses} onChange={e => setMeses(+e.target.value)}
                              style={{ width: 60, padding: '6px 8px', borderRadius: 6, border: '1px solid var(--border)', fontSize: 13 }} />
                            <span style={{ fontSize: 12, color: 'var(--text4)' }}>mes(es) gratis</span>
                          </div>
                          <div style={{ fontSize: 11, color: 'var(--text4)', marginBottom: 8 }}>Se suman al vencimiento actual</div>
                          <button onClick={() => run('regalar_meses', { meses })} disabled={!!loading}
                            style={{ width: '100%', padding: '7px', background: '#16a34a', color: 'white', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                            {loading === 'regalar_meses' ? 'Guardando...' : 'Regalar'}
                          </button>
                        </div>

                        {/* Extender trial */}
                        <div style={{ background: 'white', border: '1px solid var(--border)', borderRadius: 10, padding: 16 }}>
                          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)', marginBottom: 10 }}>Extender trial</div>
                          <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 8 }}>
                            <input type="number" min={1} max={90} value={dias} onChange={e => setDias(+e.target.value)}
                              style={{ width: 60, padding: '6px 8px', borderRadius: 6, border: '1px solid var(--border)', fontSize: 13 }} />
                            <span style={{ fontSize: 12, color: 'var(--text4)' }}>días adicionales</span>
                          </div>
                          <button onClick={() => run('extender_trial', { dias })} disabled={!!loading}
                            style={{ width: '100%', padding: '7px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                            {loading === 'extender_trial' ? 'Guardando...' : 'Extender'}
                          </button>
                        </div>

                        {/* Cancelar */}
                        <div style={{ background: 'white', border: '1px solid var(--border)', borderRadius: 10, padding: 16 }}>
                          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)', marginBottom: 10 }}>Cancelar suscripción</div>
                          <div style={{ fontSize: 11, color: 'var(--text4)', marginBottom: 12 }}>El estudio pasará a modo lectura.</div>
                          <button onClick={() => { if (window.confirm('¿Cancelar suscripción de ' + selected.nombre + '?')) run('cancelar'); }} disabled={!!loading}
                            style={{ width: '100%', padding: '7px', background: '#dc2626', color: 'white', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                            {loading === 'cancelar' ? 'Cancelando...' : 'Cancelar suscripción'}
                          </button>
                        </div>
                      </div>
                      {ok && <div style={{ marginTop: 12, color: ok.startsWith('✗') ? '#dc2626' : '#16a34a', fontSize: 13, fontWeight: 600 }}>{ok}</div>}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      {estudios.length === 0 && <div style={{ textAlign: 'center', padding: 40, color: 'var(--text4)', fontSize: 13 }}>No hay estudios registrados.</div>}
    </div>
  );
}

// ─── Tab Códigos ───────────────────────────────────────────────────────────────
function TabCodigos({ codigos, onRefresh }) {
  const [form, setForm] = useState({ codigo: '', tipo: 'meses_gratis', valor: 1, plan: '', usos_maximos: 1, vence_en: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  async function crear(e) {
    e.preventDefault();
    if (!form.codigo.trim()) { setError('Ingresá un código.'); return; }
    setLoading(true); setError('');
    const r = await accion({ accion: 'crear_codigo', ...form, valor: +form.valor, usos_maximos: +form.usos_maximos });
    setLoading(false);
    if (r.ok) { setForm({ codigo: '', tipo: 'meses_gratis', valor: 1, plan: '', usos_maximos: 1, vence_en: '' }); onRefresh(); }
    else setError(r.error || 'Error al crear el código');
  }

  async function toggle(id, activo) {
    await accion({ accion: 'toggle_codigo', id, activo: !activo });
    onRefresh();
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: 24, alignItems: 'start' }}>

      {/* Crear código */}
      <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, padding: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)', marginBottom: 16 }}>Crear código</div>
        <form onSubmit={crear} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: 4 }}>Código</label>
            <input className="form-input" value={form.codigo} onChange={e => set('codigo', e.target.value.toUpperCase())} placeholder="PROMO2025" />
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: 4 }}>Tipo</label>
            <select className="form-input" value={form.tipo} onChange={e => set('tipo', e.target.value)}>
              <option value="meses_gratis">Meses gratis</option>
              <option value="porcentaje">% de descuento</option>
            </select>
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: 4 }}>
              {form.tipo === 'meses_gratis' ? 'Cantidad de meses' : '% de descuento'}
            </label>
            <input className="form-input" type="number" min={1} max={form.tipo === 'meses_gratis' ? 12 : 100} value={form.valor} onChange={e => set('valor', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: 4 }}>Plan (opcional)</label>
            <select className="form-input" value={form.plan} onChange={e => set('plan', e.target.value)}>
              <option value="">Todos los planes</option>
              <option value="basico">Básico</option>
              <option value="profesional">Profesional</option>
              <option value="estudio">Estudio</option>
            </select>
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: 4 }}>Usos máximos</label>
            <input className="form-input" type="number" min={1} value={form.usos_maximos} onChange={e => set('usos_maximos', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: 4 }}>Vencimiento (opcional)</label>
            <input className="form-input" type="date" value={form.vence_en} onChange={e => set('vence_en', e.target.value)} />
          </div>
          {error && <div style={{ fontSize: 12, color: '#dc2626' }}>{error}</div>}
          <button type="submit" disabled={loading}
            style={{ padding: '9px', background: '#2563eb', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            {loading ? 'Creando...' : 'Crear código'}
          </button>
        </form>
      </div>

      {/* Lista de códigos */}
      <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
        <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--border)', fontSize: 14, fontWeight: 700, color: 'var(--text)' }}>
          Códigos existentes
        </div>
        {codigos.length === 0
          ? <div style={{ padding: 32, textAlign: 'center', color: 'var(--text4)', fontSize: 13 }}>No hay códigos creados.</div>
          : codigos.map(c => (
            <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderBottom: '1px solid var(--border)', opacity: c.activo ? 1 : 0.5 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)', letterSpacing: 1 }}>{c.codigo}</div>
                <div style={{ fontSize: 11, color: 'var(--text4)' }}>
                  {c.tipo === 'meses_gratis' ? `${c.valor} mes(es) gratis` : `${c.valor}% descuento`}
                  {c.plan ? ` · ${PLAN_LABEL[c.plan]}` : ' · Todos los planes'}
                  {' · '}{c.usos_actuales}/{c.usos_maximos} usos
                  {c.vence_en ? ` · Vence ${new Date(c.vence_en).toLocaleDateString('es-AR')}` : ''}
                </div>
              </div>
              <button onClick={() => toggle(c.id, c.activo)}
                style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid var(--border)', background: c.activo ? '#fee2e2' : '#dcfce7', color: c.activo ? '#dc2626' : '#16a34a', cursor: 'pointer', fontWeight: 600 }}>
                {c.activo ? 'Desactivar' : 'Activar'}
              </button>
            </div>
          ))
        }
      </div>
    </div>
  );
}

// ─── Tab Precios ───────────────────────────────────────────────────────────────
function TabPrecios({ precios: preciosIniciales, onRefresh }) {
  const [precios, setPrecios] = useState(preciosIniciales);
  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState('');

  useEffect(() => setPrecios(preciosIniciales), [preciosIniciales]);

  const setP = (plan, campo, valor) => setPrecios(ps => ps.map(p => p.plan === plan ? { ...p, [campo]: valor } : p));

  async function guardar() {
    setLoading(true); setOk('');
    const r = await accion({ accion: 'actualizar_precios', precios });
    setLoading(false);
    if (r.ok) { setOk('✓ Precios actualizados'); onRefresh(); setTimeout(() => setOk(''), 3000); }
  }

  return (
    <div style={{ maxWidth: 600 }}>
      <div style={{ fontSize: 13, color: 'var(--text4)', marginBottom: 20 }}>
        Los precios se usan en el checkout. Los cambios aplican a nuevas suscripciones.
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {precios.map(p => (
          <div key={p.plan} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 16 }}>
            <div style={{ width: 100, fontSize: 14, fontWeight: 700, color: 'var(--text)' }}>{PLAN_LABEL[p.plan]}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <label style={{ fontSize: 11, color: 'var(--text4)', fontWeight: 600 }}>USD</label>
              <input type="number" value={p.precio_usd} onChange={e => setP(p.plan, 'precio_usd', +e.target.value)}
                style={{ width: 80, padding: '6px 8px', borderRadius: 6, border: '1px solid var(--border)', fontSize: 13, textAlign: 'right' }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <label style={{ fontSize: 11, color: 'var(--text4)', fontWeight: 600 }}>ARS</label>
              <input type="number" value={p.precio_ars} onChange={e => setP(p.plan, 'precio_ars', +e.target.value)}
                style={{ width: 100, padding: '6px 8px', borderRadius: 6, border: '1px solid var(--border)', fontSize: 13, textAlign: 'right' }} />
            </div>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 20 }}>
        <button onClick={guardar} disabled={loading}
          style={{ padding: '10px 24px', background: '#2563eb', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
          {loading ? 'Guardando...' : 'Guardar precios'}
        </button>
        {ok && <span style={{ fontSize: 13, color: '#16a34a', fontWeight: 600 }}>{ok}</span>}
      </div>
    </div>
  );
}

// ─── Panel principal ───────────────────────────────────────────────────────────
export default function Admin() {
  const [tab, setTab] = useState('usuarios');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const cargar = useCallback(async () => {
    setLoading(true);
    const r = await adminFetch('/api/admin-data');
    if (r.error) setError(r.error);
    else setData(r);
    setLoading(false);
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const TABS = [
    { id: 'usuarios', label: `Usuarios (${data?.estudios?.length ?? '…'})` },
    { id: 'codigos',  label: `Códigos (${data?.codigos?.length ?? '…'})` },
    { id: 'precios',  label: 'Precios' },
  ];

  if (loading && !data) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 300, color: 'var(--text4)', fontSize: 14 }}>
      Cargando panel...
    </div>
  );

  if (error) return (
    <div style={{ padding: 40, color: '#dc2626', fontSize: 13 }}>Error: {error}</div>
  );

  return (
    <div style={{ padding: '32px 24px', maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', margin: '0 0 4px' }}>Panel de control</h1>
        <p style={{ fontSize: 13, color: 'var(--text4)', margin: 0 }}>Gestión de estudios, suscripciones, códigos y precios.</p>
      </div>

      {/* Métricas rápidas */}
      {data && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 28 }}>
          {[
            { label: 'Estudios', valor: data.estudios.length },
            { label: 'Activos', valor: data.estudios.filter(e => e.suscripciones?.[0]?.estado === 'activa').length, color: '#16a34a' },
            { label: 'En trial', valor: data.estudios.filter(e => e.suscripciones?.[0]?.estado === 'trial').length, color: '#d97706' },
            { label: 'Cancelados', valor: data.estudios.filter(e => e.suscripciones?.[0]?.estado === 'cancelada').length, color: '#dc2626' },
          ].map(m => (
            <div key={m.label} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: '14px 18px' }}>
              <div style={{ fontSize: 24, fontWeight: 800, color: m.color || 'var(--text)' }}>{m.valor}</div>
              <div style={{ fontSize: 12, color: 'var(--text4)', marginTop: 2 }}>{m.label}</div>
            </div>
          ))}
        </div>
      )}

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '1px solid var(--border)', paddingBottom: 0 }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{
              padding: '8px 16px', border: 'none', background: 'none', cursor: 'pointer',
              fontSize: 13, fontWeight: tab === t.id ? 700 : 400,
              color: tab === t.id ? '#2563eb' : 'var(--text4)',
              borderBottom: tab === t.id ? '2px solid #2563eb' : '2px solid transparent',
              marginBottom: -1,
            }}>
            {t.label}
          </button>
        ))}
        <button onClick={cargar} style={{ marginLeft: 'auto', padding: '6px 12px', border: '1px solid var(--border)', borderRadius: 6, background: 'transparent', fontSize: 12, color: 'var(--text4)', cursor: 'pointer' }}>
          ↻ Actualizar
        </button>
      </div>

      {data && tab === 'usuarios' && <TabUsuarios estudios={data.estudios} onRefresh={cargar} />}
      {data && tab === 'codigos'  && <TabCodigos codigos={data.codigos} onRefresh={cargar} />}
      {data && tab === 'precios'  && <TabPrecios precios={data.precios} onRefresh={cargar} />}
    </div>
  );
}
